import React from "react";

export class GeneralPrivacyPolicyPTBR extends React.Component {
    render() {
        return (
            <>
                <p>
                    Data de revisão: <b>28/01/2025</b>
                    <br />
                    <br />
                </p>
                <p>
                    DH Healthcare GmbH, uma empresa do grupo Dedalus, atribui grande importância e pretende prestar especial atenção à proteção dos seus dados pessoais e ao
                    respeito pela sua privacidade.
                    <br />O objetivo desta política de privacidade e desta nota informativa para os usuários do site (doravante denominada "nota") é, portanto, informá-lo de como
                    seus dados pessoais são tratados quando você visita um portal DeepUnity PACSonWEB, como, por exemplo, brazil.imaging.dedalus.com (doravante denominado "site").
                    <br />A este respeito, note que a “Dedalus” atua como controlador dos seus dados pessoais (doravante referidos como "nós", "nos" e "nosso").
                    <br />
                    <br />
                    Confirmamos expressamente que todos os dados pessoais serão processados de acordo com a Lei Geral de Proteção de Dados Nº 13.709/2018 ("LGPD") sobre a proteção
                    de pessoas físicas com relação ao processamento de dados pessoais. Isso é importante e, portanto, recomendamos que você reserve um tempo para ler esta política
                    com atenção.
                </p>
                <h2>ESCOPO DESTA POLÍTICA DE PRIVACIDADE</h2>
                <p>Esta política de privacidade se aplica</p>
                <ul>
                    <li>
                        a todas as informações pessoais coletadas dos usuários da plataforma DeepUnity PACSonWEB. Isso inclui todos os médicos, dentistas, especialistas, ... que se
                        registram e usam o DeepUnity PACSonWEB por meio de uma conta, bem como usuários não registrados que abrem uma consulta usando o número de referência e a
                        data de nascimento.
                    </li>
                    <li>todos os termos e condições e outras políticas da DH Healthcare GmbH aplicáveis aos serviços fornecidos,</li>
                </ul>
                <p>
                    Esta política de privacidade não se aplica aos dados de pacientes processados pela DH Healthcare GmbH em nome de hospitais e departamentos de radiologia
                    vinculados. Isso inclui tanto os dados médicos gerados pelo departamento de radiologia quanto os dados médicos disponibilizados a um departamento de radiologia
                    pelo próprio paciente por meio da funcionalidade de upload. Para isso, consultamos a política de privacidade do departamento de radiologia relevante.
                </p>
                <h2>1. QUE OS DADOS PESSOAIS COLETAMOS?</h2>
                <p>
                    Quando usar nosso portal, podemos coletar as seguintes categorias de dados pessoais a seu respeito:
                    <br />• dados de identificação (por exemplo, sobrenome, nome, endereço de e-mail, nome de usuário, senha, região, tipo de dispositivo).
                    <br />• dados profissionais (por exemplo, cargo ocupado, campo de atividade, empregador).
                    <br />• dados técnicos (por exemplo, endereço IP, tipo de navegador utilizado, hora de fazer o login no portal etc.); e
                    <br />• quaisquer dados pessoais contidos em qualquer correspondência que você nos envie.
                    <br />
                    <br />
                    De acordo com o artigo 18, item VIII, da Lei Geral de Proteção de Dados Nº 13.709/2018 ("LGPD"), a disponibilização de seus dados pessoais é voluntária, mas sem
                    os mesmos não poderemos fornecer-lhe os serviços e informações que solicitar. Por exemplo, se você entrar em contato conosco através do site, precisará nos
                    fornecer seu endereço de e-mail para que lhe possamos responder.
                    <br />
                    <br />
                    Em qualquer caso, informá-lo-emos quando for obrigatório facultar os seus dados pessoais.
                    <br />
                    <br />
                    Adicionalmente, se nos fornecer dados pessoais pertencentes a terceiros, se compromete a assegurar que tais pessoas foram devidamente informadas do tratamento
                    dos seus dados pessoais em conformidade com esta política e, se necessário, consentiram no tratamento dos seus dados pessoais.
                </p>
                <h2>2. POR QUE É QUE USAMOS OS SEUS DADOS PESSOAIS?</h2>
                <p>
                    A tabela abaixo destaca as finalidades para as quais tratamos seus dados pessoais e, para cada finalidade, a base legal para a operação de tratamento em
                    questão, de acordo com o artigo 7 da LGPD:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>FINALIDADES</th>
                            <th>BASE JURÍDICA</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registro de uma conta de usuário com a implementação de métodos de autenticação e autorização seguros relevantes. Isso inclui, por exemplo, o envio
                                de e-mails ou mensagens de texto para protocolos de autenticação de dois fatores;
                            </td>
                            <td>O processamento é baseado em seu consentimento.</td>
                        </tr>
                        <tr>
                            <td>Envio automático de e-mails quando um novo estudo estiver disponível para o usuário no DeepUnity PACSonWEB;</td>
                            <td>O processamento é baseado em seu consentimento.</td>
                        </tr>
                        <tr>
                            <td>Rastreabilidade do acesso registrado às informações médicas;</td>
                            <td>O tratamento é necessário para cumprir com as obrigações legais a que estamos sujeitos.</td>
                        </tr>
                        <tr>
                            <td>
                                Fornecimento da lista de usuários registrados aos hospitais que utilizam o DeepUnity PACSonWEB para distribuição. Essa lista inclui apenas o nome, o
                                primeiro nome e o número de identificação como médico
                            </td>
                            <td>O processamento é baseado em nosso interesse legítimo de informar nossos clientes sobre o uso dos serviços fornecidos.</td>
                        </tr>
                        <tr>
                            <td>
                                Responder às solicitações e perguntas que você possa enviar através do site, e de forma mais ampla, gerenciar nosso relacionamento com os visitantes
                                do site.
                            </td>
                            <td>Contrato</td>
                        </tr>
                        <tr>
                            <td>Melhorar nossos serviços e nosso site.</td>
                            <td>
                                O tratamento é realizado de acordo com nosso legítimo interesse, o que envolve a otimização de nossas ferramentas e soluções para melhor acomodar
                                nossos visitantes, clientes e potenciais clientes.
                            </td>
                        </tr>
                        <tr>
                            <td>Cumprir com as obrigações legais e regulatórias que nos são aplicáveis.</td>
                            <td>O tratamento é necessário para cumprir com as obrigações legais a que estamos sujeitos.</td>
                        </tr>
                        <tr>
                            <td>Gerenciamento de potenciais ou atuais litígios consigo ou com terceiros.</td>
                            <td>O tratamento é realizado de acordo com nosso legítimo interesse, o que envolve a defesa de nossos interesses, inclusive através de ação legal.</td>
                        </tr>
                        <tr>
                            <td>
                                Envio, utilizando meios automatizados (por exemplo, e-mail, SMS, MMS, etc.) e não automatizados (por exemplo, telefone, correio comum, etc.),
                                mensagens de marketing e mensagens de conteúdo promocional relativas às nossas atividades, produtos e serviços e as de outras empresas do grupo
                                Dedalus (incluindo pesquisas de mercado, pesquisas de satisfação de clientes, informações sobre webinars e eventos) (marketing)
                            </td>
                            <td>O tratamento é realizado somente no caso de você fornecer consentimento específico</td>
                        </tr>
                        <tr>
                            <td>
                                Compartilhamento de seus dados pessoais com outras empresas do grupo Dedalus estabelecidas em seu país/região, para permitir que elas lhe enviem,
                                usando meios automatizados (por exemplo, e-mail, SMS, MMS, etc.) mensagens de marketing e mensagens de conteúdo promocional relacionadas às suas
                                atividades, produtos e serviços (incluindo pesquisas de mercado, pesquisas de satisfação do cliente, informações sobre webinars e eventos)
                                (compartilhamento para fins de marketing)
                            </td>
                            <td>O tratamento é realizado somente no caso de você fornecer consentimento específico</td>
                        </tr>
                    </tbody>
                </table>
                <p>Em qualquer caso, note que não trataremos os seus dados pessoais para qualquer outra finalidade que seja incompatível com as finalidades acima mencionadas.</p>
                <h2>3. COM QUEM COMPARTILHAMOS SEUS DADOS PESSOAIS?</h2>
                <p>
                    No contexto das nossas operações de tratamento, podemos comunicar seus dados pessoais aos seguintes destinatários:
                    <br />• aos nossos prestadores de serviços, fornecedores, agentes e contratantes, na medida em que nos assistem na concretização dos objetivos estabelecidos
                    nesta política (por exemplo, utilizamos prestadores de serviços de TI para alojar os seus dados pessoais em nosso nome).
                    <br />• a outras entidades do Grupo Dedalus na medida em que elas nos assistem na concretização dos objetivos estabelecidos nesta política
                    <br />• aos tribunais competentes, autoridades públicas, agências governamentais e agências de aplicação da lei (incluindo onde somos obrigados a cumprir os
                    pedidos legais ou regulamentares).
                    <br />
                    <br />
                    Independentemente do destinatário, apenas lhes divulgaremos os seus dados pessoais com base na estrita necessidade de os conhecer e apenas na medida necessária
                    para cumprir os objetivos identificados nesta política.
                    <br />
                    <br />
                    Não vendemos seus dados pessoais.
                </p>
                <h2>4. TRANSFERIMOS DADOS PARA FORA DO BRASIL?</h2>
                <p>
                    Em relação às operações de tratamento descritas nesta política, podemos transferir os seus dados pessoais para fora do Brasil, inclusive para países que não são
                    reconhecidos pelo Brasil como fornecendo um nível adequado de proteção de dados.
                    <br />
                    <br />
                    Neste contexto, garantimos que o nível de proteção dos seus dados pessoais não é afetado negativamente por tais transferências.
                    <br />
                    <br />
                    Isto significa especificamente que cada uma das transferências pretendidas se baseia num dos seguintes mecanismos, pelo menos:
                    <br />• cláusulas contratuais específicas para uma determinada transferência;
                    <br />• cláusulas contratuais padrão;
                    <br />• normas empresariais globais;
                    <br />• selos, certificados e códigos de conduta emitidos regularmente;
                    <br />• quando a transferência é necessária para a cooperação jurídica internacional entre os serviços públicos de informação, investigação e ação penal, em
                    conformidade com os instrumentos de direito internacional;
                    <br />• quando a transferência é necessária para proteger a vida ou a segurança física do titular ou de um terceiro;
                    <br />• quando a autoridade nacional autoriza a transferência;
                    <br />• quando a transferência resulta num compromisso assumido num acordo de cooperação internacional;
                    <br />• quando a transferência é necessária para a execução da ordem pública ou atribuição legal do serviço público, sendo a publicidade feita nos termos do
                    ponto I do caput do art. 23 desta Lei;
                    <br />• quando o titular tiver dado o seu consentimento específico e proeminente para a transferência, com informações prévias sobre a natureza internacional da
                    operação, distinguindo-a claramente de outras finalidades; ou
                    <br />• para cumprimento de uma obrigação legal ou regulamentar por parte do responsável pelo tratamento;
                    <br />• quando necessário para a execução de um contrato ou procedimentos preliminares relacionados com um contrato do qual a pessoa em causa é uma parte, a
                    pedido da pessoa em causa;
                    <br />
                    para o exercício regular dos direitos em processos judiciais, administrativos ou arbitrais, este último nos termos da Lei n.º 9.307, de 23 de setembro de 1996
                    (Lei de Arbitragem);Pode obter cópias destes documentos enviando um e-mail ao nosso Responsável pela Proteção de Dados ("RPD"), cujos dados de contacto são
                    indicados na Secção 7 (Como nos pode contactar?) abaixo.
                </p>
                <h2>5. DURANTE QUANTO TEMPO ARMAZENAMOS OS SEUS DADOS PESSOAIS?</h2>
                <p>
                    Armazenamos seus dados pessoais por um período não superior ao necessário para as finalidades do tratamento em questão.
                    <br />
                    <br />
                    Por outras palavras, isto significa que os períodos de armazenamento que aplicamos variam consoante a finalidade para a qual tratamos os dados em questão. A
                    tabela abaixo indica, por isso, para cada finalidade, o período de armazenamento que será aplicado aos seus dados pessoais:
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>FINALIDADES</th>
                            <th>PERÍODO DE ARMAZENAMENTO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Registro de uma conta de usuário com a implementação de métodos de autenticação e autorização seguros relevantes. Isso inclui, por exemplo, o envio
                                de e-mails ou mensagens de texto para protocolos de autenticação de dois fatores;
                            </td>
                            <td>
                                Os dados pessoais, fornecidos no contexto de um registro de conta, serão mantidos por um período de 2 anos após a última tentativa de login
                                bem-sucedida.
                            </td>
                        </tr>
                        <tr>
                            <td>Envio automático de e-mails quando um novo estudo estiver disponível para o usuário no DeepUnity PACSonWEB;</td>
                            <td>
                                Os dados pessoais, fornecidos no contexto de um registro de conta, serão mantidos por um período de 2 anos após a última tentativa de login
                                bem-sucedida.
                            </td>
                        </tr>
                        <tr>
                            <td>Rastreabilidade do acesso registrado às informações médicas;</td>
                            <td>10 anos</td>
                        </tr>
                        <tr>
                            <td>
                                Fornecimento da lista de usuários registrados aos hospitais que utilizam o DeepUnity PACSonWEB para distribuição. Essa lista inclui apenas o nome, o
                                primeiro nome e o número de identificação como médico
                            </td>
                            <td>
                                Os dados pessoais, fornecidos no contexto de um registro de conta, serão mantidos por um período de 2 anos após a última tentativa de login
                                bem-sucedida.
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Envio, utilizando meios automatizados (por exemplo, e-mail, SMS, MMS, etc.) e não automatizados (por exemplo, telefone, correio comum, etc.),
                                mensagens de marketing e mensagens de conteúdo promocional relativas às nossas atividades, produtos e serviços e as de outras empresas do grupo
                                Dedalus (incluindo pesquisas de mercado, pesquisas de satisfação de clientes, informações sobre webinars e eventos) (marketing)
                            </td>
                            <td>Nós trataremos seus dados pessoais até que seu consentimento seja retirado.</td>
                        </tr>
                        <tr>
                            <td>
                                Compartilhamento de seus dados pessoais com outras empresas do grupo Dedalus estabelecidas em seu país/região, para permitir que elas lhe enviem,
                                usando meios automatizados (por exemplo, e-mail, SMS, MMS, etc.) mensagens de marketing e mensagens de conteúdo promocional relacionadas às suas
                                atividades, produtos e serviços (incluindo pesquisas de mercado, pesquisas de satisfação do cliente, informações sobre webinars e eventos)
                                (compartilhamento para fins de marketing)
                            </td>
                            <td>Nós trataremos seus dados pessoais até que seu consentimento seja retirado.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Em qualquer caso, uma vez decorrido o período de armazenamento aplicável, apagaremos irrevogavelmente ou tornaremos anónimos os seus dados pessoais para que não
                    possa mais ser identificado.
                </p>
                <h2>6. NÓS USAMOS COOKIES?</h2>
                <p>
                    Utilizamos cookies em nosso site.
                    <br />
                    Para saber mais sobre os cookies que usamos e as finalidades para as quais os utilizamos, consulte nossa política de cookies, que pode ser encontrada na seção
                    de privacidade da página do site.
                </p>
                <h2>7. QUE DIREITOS LHE ASSISTEM?</h2>
                <p>
                    Em conformidade com o quadro jurídico aplicável em matéria de proteção de dados, em especial a LGPD, tem os seguintes direitos como titular dos dados:
                    <br />• Pode solicitar a confirmação da existência de tratamento.
                    <br />• Pode solicitar o acesso aos seus dados pessoais e solicitar que estes sejam retificados ou apagados.
                    <br />• Pode solicitar a correcção de dados incompletos, imprecisos ou desactualizados;
                    <br />• Pode solicitar a anonimização, bloqueio ou eliminação de desnecessários, excessivos ou processados em violação da LGPD.
                    <br />• Tem também o direito de solicitar que o tratamento dos seus dados pessoais seja restringido ou de se opor aos mesmos.
                    <br />• Tem o direito à portabilidade dos seus dados pessoais para outro fornecedor de serviços ou produtos, mediante pedido expresso em conformidade com a
                    regulamentação da autoridade nacional (CNPD), observando os segredos comerciais e industriais.
                    <br />
                    <br />
                    Tem também o direito à informação sobre as entidades públicas e privadas com as quais o responsável pelo tratamento fez uso comum dos dados;
                    <br />• Tem direito à informação sobre a possibilidade de não dar o consentimento e as consequências de não dar o consentimento;
                    <br />• Quando o tratamento dos seus dados pessoais se baseia no seu consentimento, queira notar que pode retirar o seu consentimento em qualquer altura, sem
                    afetar a legalidade do tratamento baseado no seu consentimento efetuado antes da retirada dos mesmos
                    <br />
                    <br />
                    Para exercer seus direitos, entre em contato com nosso DPO usando os detalhes de contato fornecidos na Seção 7 (Como você pode entrar em contato conosco?). Para
                    processar o seu pedido da forma mais eficiente possível, podemos pedir-lhe determinadas informações adicionais para confirmar a sua identidade e/ou ajudar a
                    localizar os dados pessoais que constituem o objeto do seu pedido.
                    <br />
                    <br />
                    Em qualquer caso, observe que você pode apresentar uma reclamação à autoridade supervisora de proteção de dados relevante no seguinte link
                    https://www.gov.br/anpd/pt-br/canais_atendimento/cidadao-titular-de-dados/denuncia-de-descumprimento-da-lgpd
                </p>
                <h2>8. COMO NOS PODE CONTACTAR?</h2>
                <p>
                    Em caso de dúvidas ou solicitações relacionadas às nossas operações de processamento dos seus dados pessoais de acordo com esta política, incluindo o exercício
                    dos seus direitos, conforme descrito acima, você pode entrar em contato conosco pelo seguinte endereço: du_pacsonweb@dedalus.eu.
                    <br />
                    <br />
                    Nós também nomeamos um Diretor de Proteção de Dados ("DPO"), que você pode contatar por e-mail para o seguinte endereço:
                    <br />- Dedalus S.p.A. dpo.group@dedalus.eu
                    <br />- Millennium S.r.l. dpo.millennium@dedalus.eu
                    <br />- para outras empresas sediadas na Itália dpo@dedalus.eu
                    <br />- para empresas sediadas no Reino Unido dpo-uk@dedalus.group.
                    <br />- para empresas sediadas na França dpo.france@dedalus.eu
                    <br />- para empresas sediadas na Alemanha/Áustria e Suíça dpo.dach@dedalus.com
                    <br />- para a DH Healthcare GmbH e outras empresas sediadas na Bélgica dpo.belgium@dedalus.eu
                    <br />- para outras empresas dpo.group@dedalus.eu
                </p>
            </>
        );
    }
}
